import {ClvrDarkenColor, ClvrPrimaryColor} from "../../../core/vue/constants/ClvrBaseThemeColors";

export default {
    themes: {
        light: {
            primary: {
                base: ClvrPrimaryColor,
                darken1: ClvrDarkenColor,
            },
            secondary: '#b0bec5',
            anchor: '#8c9eff',
        },
    },
    options: {
        customProperties: true
    }
}
